import type { ReportingApiQuotaItem } from '../types/reporting-api-usage.types';

export function formatRatePercent(value: number): string {
  return `${(value * 100).toFixed(1)}%`;
}

export function formatCount(value: number): string {
  return new Intl.NumberFormat('en-GB').format(value);
}

export function formatQuotaConsumption(quota: ReportingApiQuotaItem): string {
  return `${formatCount(quota.current)} / ${formatCount(quota.limit)}`;
}

export function formatDateTime(value: string | null | undefined): string {
  if (!value) {
    return '—';
  }
  return new Intl.DateTimeFormat('en-GB', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(value));
}

export function formatKeyLabel(name: string, prefix: string, lastFour: string): string {
  return `${name} (${prefix}…${lastFour})`;
}

export function isReportingApiUsageNotAuthorised(error: unknown): boolean {
  if (!error || typeof error !== 'object' || !('status' in error)) {
    return false;
  }
  const status = (error as { status?: unknown }).status;
  return status === 403 || status === 404;
}

export function getReportingApiUsageErrorMessage(error: unknown): string {
  if (isReportingApiUsageNotAuthorised(error)) {
    return 'Reporting API usage is available to Invisibly staff only.';
  }
  if (error && typeof error === 'object' && 'status' in error && typeof error.status === 'number') {
    return `Unable to load reporting API usage (HTTP ${error.status}).`;
  }
  return 'Unable to load reporting API usage.';
}
